/* eslint-disable no-underscore-dangle */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import PaymentGateways from "../config/paymentGateways";

export default function useClearSale() {
  
  const appKey = useSelector((state) => state.property.config.paymentGatewayAntifraudFingerprintId);
  const paymentGatewayId = useSelector((state) => state.property.config.paymentGatewayId);
  
  useEffect(() => {
    
    if (!appKey || Number.parseInt(paymentGatewayId, 10) !== PaymentGateways.ZOOP) return;

    // evita reinicializar em SPA
    if (window.__clearsaleLoaded) return;

    window.__clearsaleLoaded = true;

    // cria sessionId se não existir
    let sessionId = sessionStorage.getItem("clearSaleSessionId");

    if (!sessionId) {
      sessionId = crypto.randomUUID();
      sessionStorage.setItem("clearSaleSessionId", sessionId);
    }

    // cria objeto csdp se ainda não existir
    window.csdp =
      window.csdp ||
      // eslint-disable-next-line func-names
      function () {
        // eslint-disable-next-line prefer-rest-params
        (window.csdp.q = window.csdp.q || []).push(arguments);
      };

    window.csdp("app", appKey);
    window.csdp("sessionid", sessionId);


    // carrega script da clearsale
    const script = document.createElement("script");
    script.src = "https://device.clearsale.com.br/p/fp.js";
    script.async = true;

    document.body.appendChild(script);
  }, [appKey, paymentGatewayId]);
}